// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2777":"fde713e4","4181":"fde713e4","5306":"33d1a522"}[chunkId] + ".chunk.css";
};